module.exports = __webpack_public_path__ + "img/item(10).9523493b.svg";